enum VideoInfoEvents {
    // 動画出力情報更新
    UpdateVideoInfoStarted = "[VideoInfoEvents] UpdateVideoInfoStarted",
    UpdateVideoInfoComplete = "[VideoInfoEvents] UpdateVideoInfoComplete",
    UpdateExportVideoInfo = "[VideoInfoEvents] UpdateExportVideoInfo",
}

export default VideoInfoEvents;
